let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6kPNO")).then(() => parcelRequire('bMF5U'));